import React, { ComponentPropsWithoutRef, Context, createContext, useContext, useEffect, useMemo, useState } from 'react'

type VideoContextValue = {
  searchString: string
  setSearchString: (param: string) => void
  productId: number
  setProductId: (param: any) => void
  productCategoryId: string
  setProductCategoryId: (param: string) => void
  proId: number
  setProId: (param: any) => void
  aspectRatio: string
  setAspectRatio: (param: string) => void
  contentCode: string
  setContentCode: (param: string) => void
  extraFilter: string
  setExtraFilter: (param: string) => void
  videoId: number
  setVideoId: (param: number) => void
  embed: string
  setEmbed: (param: string) => void
}

export const VideoContext: Context<VideoContextValue> = createContext({
  searchString: '',
  productId: 0,
  productCategoryId: '',
  proId: 0,
  aspectRatio: '',
  extraFilter: '',
  contentCode: '',
  embed: '',
  videoId: 0,
  setSearchString: (param) => {},
  setProductId: (param) => {},
  setProductCategoryId: (param) => {},
  setProId: (param) => {},
  setAspectRatio: (param) => {},
  setContentCode: (param) => {},
  setExtraFilter: (param) => {},
  setVideoId: (param) => {},
  setEmbed: (param) => {},
})

export const VideoContextWrapper = ({ children }: ComponentPropsWithoutRef<'div'>) => {
  const [searchString, setSearchString] = useState('')
  const [productId, setProductId] = useState<number>(0)
  const [productCategoryId, setProductCategoryId] = useState('')
  const [proId, setProId] = useState<number>(0)
  const [aspectRatio, setAspectRatio] = useState('')
  const [extraFilter, setExtraFilter] = useState('')
  const [contentCode, setContentCode] = useState('')
  const [embed, setEmbed] = useState('')
  const [videoId, setVideoId] = useState<number>(0)

  const updateSearchString = (input: string) => {
    setSearchString(input)
  }

  const updateProductId = (input: any) => {
    setProductId(input)
  }

  const updateAspectRatio = (input: string) => {
    setAspectRatio(input)
  }

  const updateContentCode = (input: string) => {
    setContentCode(input)
  }

  const ctxValue = useMemo(
    () => ({
      searchString,
      setSearchString: updateSearchString,
      productId,
      setProductId: updateProductId,
      productCategoryId,
      setProductCategoryId,
      aspectRatio,
      setAspectRatio: updateAspectRatio,
      proId,
      setProId,
      extraFilter,
      setExtraFilter,
      contentCode,
      setContentCode: updateContentCode,
      videoId,
      setVideoId,
      embed,
      setEmbed,
    }),
    [searchString, productId, productCategoryId, aspectRatio, proId, extraFilter, contentCode, videoId]
  )

  return <VideoContext.Provider value={ctxValue}>{children}</VideoContext.Provider>
}

export const useVideoContext = () => {
  const videoCtx = useContext(VideoContext)

  return {
    ...videoCtx,
  }
}
